import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="hussar-loading-screen">
        <Loader2 className="w-12 h-12 animate-spin" style={{ color: '#00D4FF' }} />
        <p style={{ color: '#FFFFFF', marginTop: '20px' }}>{t('app.loading')}</p>
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (user.role !== 'admin') {
    return <Navigate to="/app" replace />;
  }

  return children;
};

export default AdminRoute;
